import React from 'react';
import { useFormContext } from 'ui-builder';
import { Textarea, cn } from 'shadcn-ui';
import type { TextAreaLayoutProps } from './TextAreaLayout';
import MaxLengthInfo from './MaxLengthInfo';
import ShadcnBaseInputLayout from '../../layout/ShadcnBaseInputLayout';

function ShadcnTextAreaLayout(props: TextAreaLayoutProps) {
  const formContext = useFormContext();

  const maxLength = formContext.getConstraintValue
    ? formContext.getConstraintValue(props.name, 'maxLength')
    : undefined;

  return (
    <ShadcnBaseInputLayout
      name={props.name}
      label={props.label}
      errors={props.errors}
      hideLabel={props.hideLabel}
      showRequiredIcon={props.showRequiredIcon}
      className={props.className}
      hint={props.hint}
    >
      <Textarea
        name={props.name}
        onChange={props.onChangeCallback}
        value={props.value || ''}
        placeholder={props.placeholder}
        disabled={props.isDisabled}
        maxLength={maxLength || undefined}
        className={cn(props.small && 'min-h-[4rem]')}
      />
      <MaxLengthInfo name={props.name} value={props.value || ''} />
    </ShadcnBaseInputLayout>
  );
}

export default ShadcnTextAreaLayout;
